import React from 'react';
import type { FilterOptionViewModel } from 'autogen/swagger/all';
import PageSizeOption from './PageSizeOption';

export default function PageSizeOptionsRenderer({ model: pageSizeOptions }: { model: FilterOptionViewModel[] }) {
    return (
        <>
            {pageSizeOptions.map((pageSizeOption) => (
                <PageSizeOption key={pageSizeOption.value || 1} model={pageSizeOption} />
            ))}
        </>
    );
}
